var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"gate login"},[_vm._m(0),_c('ChangePassword',{attrs:{"resetToken":_vm.token}}),_c('hr')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"together"},[_c('img',{attrs:{"src":"/rallyhood-white.svg"}}),_vm._v(" Together with purpose! ")])
}]

export { render, staticRenderFns }